import React, { useEffect, useState } from 'react';
import { showAxiosMessageError } from '../../../services/error-message.service';
import { searchPages } from '../../../services/page.service';
import { useSnackbars } from '../../../hooks/snackbar.hook';
import { Skeleton } from '@mui/material';
import { PagesPaginationDto } from '../../../services/dtos/pages-pagination.dto';
import PagesContentsTable from '../../../components/table/admin/pages/pages-contents.table';
import { env } from '../../../env';

/**
 * Composant de la page du tableau des pages
 */
export default function PageContentPage(): JSX.Element {
    //mise en place des différents useState
    // Snackbar des messages
    const showMessage = useSnackbars();
    const [loading, setLoading] = useState<boolean>(false);
    const [init, setInit] = useState<boolean>(false);
    const [pages, setPages] = useState<PagesPaginationDto | null>(null);
    // Page affichée
    const [page, setPage] = useState(0);
    // Nombre de lignes par page, géré par une variable d'environnement
    const rowsPerPage = Number(env.REACT_APP_NUMBER_ELEMENT_TABLE_ADMIN);

    /**
     * Récupération des contrats associés à l'utilisateur connecté
     */
    useEffect(() => {
        setLoading(true);
        searchPages(page + 1, rowsPerPage)
            .then(result => {
                // Formattage de tous les contrats pour supprimer l'url de leur id
                result?.pages.forEach(resultPage => {
                    if (resultPage['@id'] && typeof resultPage['@id'] === 'string') {
                        resultPage.id = Number(resultPage['@id'].replace('/parametre_agence_en_lignes/', ''));
                    }
                });
                setPages(result);
            })
            .catch(error => {
                console.error('Erreur lors de la récupération des pages.');
                showAxiosMessageError(error, showMessage);
            })
            .finally(() => {
                setLoading(false);
                if (!init) {
                    setInit(true);
                }
            });
    }, [init, page, rowsPerPage, showMessage]);

    /**
     * Changement de page qui va déclancher le useEffect
     * @param newPage
     */
    const handleSwitchPageNumber = (newPage: number) => {
        setPage(newPage);
    };

    //A l'initialisation on met un skeleton sinon un slider est géré dans le tableau pour les changement de pages
    if (init) {
        return (
            <PagesContentsTable
                page={page}
                rowsPerPage={rowsPerPage}
                pages={pages}
                handleSwitchPageNumber={handleSwitchPageNumber}
                isSearching={loading}
            />
        );
    } else {
        return <Skeleton variant="rectangular" height={250}></Skeleton>;
    }
}
